import { getHotProduct, getCollectProduct } from 'model/product';
import { openWarningAlertOnError } from 'model/alert';

export default store => ({
	path: 'collection',
	indexRoute: {
		getComponent: (nextState, cb) =>
			require.ensure(
				[],
				require => {
					const component = require('./component').default;
					cb(null, component);
				},
				'Collection',
			),
	},
	onEnter: (_, __, callback) => {
		const {
			auth: { accessToken },
		} = store.getState();

		if (accessToken === '') {
			store.dispatch(openWarningAlertOnError('請先登入'));
			callback();
			return;
		}

		store.dispatch(getHotProduct());
		store.dispatch(getCollectProduct());

		callback();
	},
});
